// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import Mint from 'mint-ui'
import './assets/main.scss'
var SocialSharing = require('vue-social-sharing');

Vue.config.productionTip = false

Vue.use(Mint)
Vue.use(Utils)
Vue.use(SocialSharing)

import Utils from './utils'
window.Utils = Utils

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

Vue.mixin({
    methods: {
        $messagebox_lang(opt){
            if(typeof opt == 'object'){
                return this.$messagebox(opt)
            }else{
                return this.$messagebox({title:'', message:opt, confirmButtonText:'ok'})
            }
        },
        langMsg(obj, key){
            return obj[`${key}_${this.lang}`] || obj[key];
        }
    }
})
import VideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';

Vue.use(VideoPlayer);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js